/** @description Определение текущих настроек карусели в зависимости от ширины контейнера
 * @param {number} width ширина контейнера карусели в пикселях
 * @param {IMedia[]} media массив настроек карусели
 * @return {IMedia}
 */
export function getCurrentMedia(width, media) {
  var currentIndex = 0;
  media.forEach(function (item, index) {
    if (item.minWidth <= width && item.maxWidth > width) {
      currentIndex = index;
    }
  });
  return media[currentIndex];
}